import Title from "../../CommonComponents/Title"
import { TiArrowForwardOutline } from "react-icons/ti";
import { BsReply } from "react-icons/bs";
import { useEffect, useState } from "react";
import ComposeEmail from "../../ComposeEmail";
import { useDispatch } from "react-redux";
import ModalComponent from "../../CommonComponents/Modal";
import { modifyEmailAsRead, modifyEmailAsReadForMicrosoft } from "../../../redux/actions/emailSettings";
import { toast } from "../../CommonComponents/ToastComponent/toast";

const EmailDetail = ({ hrLine, selectedEmail, selectedMailAndCategory, userEmails, tab  }) => {
    const dispatch = useDispatch()

    const [notificationEmailDetail, setNotificationEmailDetail] = useState({})
    const [showComposeEmailBox, setShowComposeEmailBox] = useState(false)
    const [actionOnEmailForTask, setActionOnEmailForTask] = useState(null)
    const composeEmailCloseHandler = () => {
        setShowComposeEmailBox(false)
    }

    const onReplyEmail = () => {
        setActionOnEmailForTask('reply')
        setShowComposeEmailBox(true)
    }

    const onForwardEmail = () => {
        setActionOnEmailForTask('forward')
        setShowComposeEmailBox(true)
    }

    useEffect(() => {
        if (tab === 'emails') {
            let tmpUserRegisteredEmail = userEmails?.filter(userEmail => userEmail?.email?.toLowerCase() === selectedMailAndCategory?.email?.toLowerCase())?.[0]
            if (selectedMailAndCategory?.domain === 'google' && (selectedMailAndCategory?.category === 'inbox' || selectedMailAndCategory?.category === 'junk')) {
                if (!selectedEmail?.isRead) {
                    dispatch(modifyEmailAsRead({ messageId: selectedEmail?.messageId, accessToken: tmpUserRegisteredEmail?.accessToken, refreshToken: tmpUserRegisteredEmail?.refreshToken, email: tmpUserRegisteredEmail?.email })).then((res) => {
                        toast.show({
                            title: 'Success',
                            description: 'Mail Read'
                        })
                    }).catch((err) => {
                        toast.show({
                            title: 'Danger',
                            description: 'Unable to Read email'
                        })
                    })
                }
            } else if (selectedMailAndCategory?.domain === 'microsoft' && (selectedMailAndCategory?.category === 'inbox' || selectedMailAndCategory?.category === 'junk')) {
                if (!selectedEmail.isRead) {
                    dispatch(modifyEmailAsReadForMicrosoft({ messageId: selectedEmail?.messageId, accessToken: tmpUserRegisteredEmail?.accessToken, email: tmpUserRegisteredEmail?.email })).then((res) => {
                        toast.show({
                            title: 'Success',
                            description: 'Microsoft Mail Read'
                        })
                    }).catch((err) => {
                        toast.show({
                            title: 'Danger',
                            description: 'Unable to Read email'
                        })
                    })
                }
            }
        } else if (tab === 'notifications' && Object?.keys(notificationEmailDetail).length === 0) {
            
        }
    }, [])

    return (
        <div className={`px-5 py-3 mx-4  ${!hrLine && 'mt-5'}`} style={{ height: "60% !important" }}>
            {hrLine && <hr className="mb-4" />}
            {
                showComposeEmailBox && (<ModalComponent size='md' modalTitle='' open={showComposeEmailBox} handleClose={composeEmailCloseHandler} dialogClassName='px-5 create-new-contact-modal-dialog'>
                    <ComposeEmail
                        componentFor={'tasksInEmailDetail'}
                        supplierInfo={{}}
                        vendorInfo={{}}
                        contactOptions={[]}
                        onGetExistingContacts={() => { }}
                        vendorInCallDetailsId={null}
                        contacts={[]}
                        getContactsData={() => { }}
                        activeTab={''}
                        actionOnEmailForTask={actionOnEmailForTask}
                        selectedEmail={selectedEmail}
                        domain={selectedMailAndCategory?.domain}
                        setShowComposeEmailBox={setShowComposeEmailBox}
                        composeEmailCloseHandler={composeEmailCloseHandler}
                        selectedFormatedEmail={selectedEmail}
                        setShow={setShowComposeEmailBox}
                    />
                </ModalComponent>)

            }
            {tab === 'emails' && <>
                <Title title={selectedEmail?.subject} />
                <div className="d-flex mt-4 align-items-center">
                    <button className=" btn btn-lg rounded-circle" style={{ backgroundColor: '#d9d9d9', width: 45, height: 45 }}></button>
                    <div className="mx-4">
                        <p className="fw-bold fs-4 m-0 text-black">{selectedEmail?.senderName}</p>
                        <p className="fs-4 m-0 text-black">{selectedEmail?.senderEmail}</p>
                    </div>
                </div>
                <div className=" mt-4 d-flex align-items-center flex-column " style={{ height: '70%', overflowY: 'scroll' }}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: selectedEmail?.mainBody
                        }}
                        className='mt-3 fs-4 rounded'
                    >
                    </div>
                </div>
                <div className="d-flex column-gap-3 mt-4 ">
                    <button className="report_button_success" onClick={onReplyEmail}><BsReply size={20} className="mx-2" style={{ verticalAlign: 'top' }} />Reply</button>
                    <button className="report_button_success" onClick={onForwardEmail}><TiArrowForwardOutline size={20} className="mx-2 p" style={{ verticalAlign: 'top' }} />Forward</button>
                </div>
            </>}

        </div>
    )
}

export default EmailDetail